import React from 'react';
import { Route, IndexRoute } from 'react-router';
import GeneralActionsExpiration from './actionsGeneralExpiration';

export default (
  <Route path="minhas-atividades-validade">
    <IndexRoute component={(props) => <GeneralActionsExpiration {...props} />} />
  </Route>
);
